import { APP_WRITE } from 'drapcode-constant';
import { alertMessagesArgsConfig, browserStorageArgsConfig } from '../../utils/event_constants';

export const appwriteActions = [
  {
    name: 'sendDataToExternalSource',
    label: 'Appwrite: Sign Up',
    type: 'AUTH',
    source: APP_WRITE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsAppwrite',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Appwrite: Sign In via Email & Password',
    type: 'AUTH',
    source: APP_WRITE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsAppwrite',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Appwrite: Sign Out',
    type: 'AUTH',
    source: APP_WRITE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsAppwrite',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'authorizeWithExternalDataSource',
    label: 'Appwrite: Authorize Using API',
    type: 'AUTH',
    source: APP_WRITE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsAppwrite',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sessionKey',
        label: 'Session Key',
        type: 'text',
        value: 'AUTH',
      },
    ],
  },
  {
    name: 'sendDataToExternalSource',
    label: 'Appwrite: Send Data To API',
    source: APP_WRITE,
    args: [
      {
        name: 'webhookId',
        label: 'External API',
        type: 'dropdown',
        optionsType: 'dsAppwrite',
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
];
